import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./containers/home/Home";
import styles from "./App.module.scss";
import Competition from "./containers/competitions/Competition";
import PlaymakersGrassroots from "./containers/playmakers-glassroots/PlaymakersGrassroots";
import FanClub from "./containers/fan-club/FanClub";
import Administration from "./containers/administration/Administration";
import Volunteers from "./containers/volunteers/Volunteers";
import ScrollToTop from "./containers/scroll-to-top/ScrollToTop";
import Intermediaries from "./containers/intermediaries/Intermediaries";
import Committees from "./containers/committees/Committees";
import Committee from "./containers/committee/Committee";
import Presidenti from "./containers/presidenti/Presidenti";
import NormativeActs from "./containers/normative-acts/NormativeActs";
import News from "./containers/news/News";
import NewsDetails from "./containers/news-details/NewsDetails";
import NotFound from "./containers/not-found/NotFound";
import SearchResults from "./components/search-result/SearchResults";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import FFKShop from "./containers/ffk-shop/FFK-shop";
import FFKHistory from "./containers/ffk-history/FFKHistory";
import CookieConsent from "./components/_shared/cookies/CookieConsent";
import TermsOfUse from "./containers/terms-and-conditions/TermsOfUse";
import PrivacyPolicy from "./containers/terms-and-conditions/PrivacyPolicy";
import Contact from "./containers/contact-page/Contact";
import Auditor from "./containers/auditor/Auditor";
import LicencimiIKlubeve from "./containers/lincences/LicensimiIKlubeve";
import Coaches from "./containers/coaches/Coaches";
import CoachApplicationReview from "./containers/coach-application-review/CoachApplicationReview";

const App = () => {
  return (
    <div className={styles.RoutesWrapper}>
      <ScrollToTop />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/intermediary" element={<Intermediaries />} />
        <Route path="/committees" element={<Committees />} />
        <Route path="/committee" element={<Committee />} />
        <Route path="/presidenti" element={<Presidenti />} />
        <Route path="/sekretar-i-pergjithshem" element={<Presidenti />} />
        <Route path="/normative-acts" element={<NormativeActs />} />
        <Route path="/auditor" element={<Auditor />} />
        <Route path="/licencimi-i-klubeve" element={<LicencimiIKlubeve />} />
        <Route path="/garat/:title" element={<Competition />} />
        <Route path="/lajmet" element={<News />} />
        <Route path="/lajmet/:title" element={<NewsDetails />} />
        <Route path="/administration" element={<Administration />} />
        <Route path="/ffk-historiku" element={<FFKHistory />} />
        <Route
          path="/volunteers"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
            >
              <Volunteers />
            </GoogleReCaptchaProvider>
          }
        />
        <Route
          path="/coaches"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
            >
              <Coaches />
            </GoogleReCaptchaProvider>
          }
        />
        <Route
          path="/coach-application-review"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
            >
              <CoachApplicationReview />
            </GoogleReCaptchaProvider>
          }
        />
        <Route
          path="/coaches/review/:token"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY!}
            >
              <CoachApplicationReview />
            </GoogleReCaptchaProvider>
          }
        />
        <Route path="/fan-club" element={<FanClub />} />
        <Route path="/ffk-shop" element={<FFKShop />} />
        <Route path="/playmakers" element={<PlaymakersGrassroots />} />
        <Route path="/grassroots" element={<PlaymakersGrassroots />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/termsOfUse" element={<TermsOfUse />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
};

export default App;
